export const content = {
    home: {
        header: {
            title: 'Calabash Gardens',
            subtitle: "100% Vermont and Regeneratively Grown. Oh! So Beautiful!",
            button: "Get In Touch"
        },
        banner: {
            title: 'Calabash Gardens',
            subtitle_1: "Black, Women & Worker owned.",
            subtitle_2: "One Thread at a Time",
            paragraph: "We are a progressive, innovative and sustainably minded saffron farm in Wells River, Vermont. The Farm produces the highest quality, organically grown saffron in the Northeast while striving to uphold the ethics of regenerative agricultural practices. Transparent, passionate, and inspiring the farm promotes equal opportunity while demonstrating leadership in a blossoming and dynamic US spice industry.",
            button: "Learn More"
        },
        offerings: {
            title: "Offerings",
            paragraph: "From premium saffron threads to infused saffron products, you will find the best quality with us, One Thread at a Time. Whether shopping for seasonal condiments or wild apothecary products, we have a wide selection for you to choose from. The best part is, everything is locally and responsibly grown right here in the Green Mountains, so you can enjoy our products knowing you’re supporting the community and the planet.",
            box_1: {
                title: "Premium Saffron",
                paragraph: "We offer grade A premium saffron, grown right here at Calabash Gardens from a half gram to a kilo and beyond!"
            },
            box_2: {
                title: "Apothecary",
                paragraph: "Our apothecary brings you an array of useful remedies and beauty products straight from vermont's woods and our regenerative herb garden. Capturing the medicine and essence of the wild to help facilitate your body's own natural functions."
            },
            box_3: {
                title: "Calabash Garden's Experience",
                paragraph: "Come enjoy a night of elevated farm to plate dinning with menus  featuring our very own saffron and only the most local and freshest ingredients. Guest Chefs will delight and inspire you to use saffron in your own kitchen, while pairing courses with the finest local spirits. Let yourself be serenaded away by beautiful sound waves, get lost in our enchanted, immersive ourdoor dinning experience."
            },
            box_4: {
                title: "Regenerative farming",
                paragraph: "Never heard of Regenerative Agrictulture? Let us take you on a journey past substainable, past organic, into the regenerative power of farming!"
            },
            more_info: "For more information about our products or to make an order, contact us."
        },
        about: {
            title: "About Us",
            paragraph_1: "Calabash Gardens was started in late summer of 2018 with 2000 Crocus Sativus corms. They were directly planted in the ground and were subject to the whim of nature. The test plot succesfully flowered each October, facilitating the planting of a half acre in 2020, 9 acres will follow with in the next 10 years. Using regenerative agriculture practices and a variety of cover crops for maximum biodiversity we will build soil and sequester carbon reducing our carbon footprint while activiely regenerating the landscape.",
            paragraph_2: "Calabash is on track to be a pioneer producer and distributor of the saffron spice in the western hemisphere while our community-centered business model is constructed to employ Black farmers and shareholders while bringing saffron to the plates of everyday Americans. Calabash Gardens is not just a farm, it's a movement.",
            button: "Get In Touch"
        },
        team: {
            title: "Team",
            position_1: {
                title: "President",
                name: "Claudel Chery",
                bio: "Claudel Zaka Chery, a Haitian poet and film director, moved to Newbury from Jacmel-Haiti in 2011. He was the assistant to the director of FOSAJ, Flo McGarrell. Both Mr McGarrell and Zaka ran the Jacmel art center with great energy and taste. On 12 January 2010, his beloved country of Haiti entered a nightmare from which there was no hope of waking. 316,000 people died in the 37 seconds that an earthquake moved just under the surface of the island facilitating his move to Newbury."
            },
            position_2: {
                title: "Vice President",
                name: "Jette Mandl-Abramson",
                bio: "Jette Mandl-Abramson, born in New Mexico, raised in the South coast of New Hampshire, is primarily a ceramist, herbalist and organic regenerative farmer. She has also worked in the restaurant industry for fifteen years. Her passions are great food, horticulture, animals and wild edible plants. She wants every initiative she takes to be Eco- friendly and regenerative as well as giving something back to the community."
            }
        },
    },
    saffron_pricing: {

    },
    book_online: {

    },
    shop: {

    },
    blog: {

    }
}